import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import FeaturedProjects from "@/components/site/FeaturedProjects";
import Founder from "@/components/site/Founder";
import ClientReels from "@/components/site/ClientReels";
import CoreServices from "@/components/site/CoreServices";
import Technologies from "@/components/site/Technologies";
import Pricing from "@/components/site/Pricing";
import BeforeAfter from "@/components/site/BeforeAfter";
import Industries from "@/components/site/Industries";
import WhyChoose from "@/components/site/WhyChoose";
import Process from "@/components/site/Process";
import Testimonials from "@/components/site/Testimonials";
import AuditForm from "@/components/site/AuditForm";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative">
      <Navbar />
      <main>
        <Hero />
        <FeaturedProjects />
        <Founder />
        <CoreServices />
        <Technologies />
        <Pricing />
        <BeforeAfter />
        <Industries />
        <WhyChoose />
        <Process />
        <ClientReels />
        <Testimonials />
        <AuditForm />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
